import * as React from "react"
const AnexoIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M4.89 1h8.987A3.124 3.124 0 0 1 17 4.124v1.762c0 .117 0 .25-.011.363-.013.132-.045.31-.156.488a1.092 1.092 0 0 1-.344.343 1.094 1.094 0 0 1-.487.157 3.93 3.93 0 0 1-.363.01h-3.515v9.067a.686.686 0 0 1-.903.65L9 16.225l-2.221.74a.686.686 0 0 1-.434 0l-2.221-.74-2.221.74a.686.686 0 0 1-.903-.65V4.89c0-.727 0-1.34.066-1.828.07-.519.224-.998.61-1.385.388-.387.867-.542 1.386-.611C3.55 1 4.163 1 4.89 1Zm7.234 4.876h3.504V4.124a1.752 1.752 0 0 0-3.504 0v1.752Zm-.834-3.505H4.937c-.786 0-1.306.002-1.693.054-.366.05-.508.132-.597.222-.09.09-.173.23-.222.597-.052.387-.054.907-.054 1.693v10.426l1.536-.512a.686.686 0 0 1 .434 0l2.22.74 2.222-.74a.686.686 0 0 1 .434 0l1.535.512V4.123c0-.649.199-1.252.538-1.752ZM8.187 5.622h-3.25a.686.686 0 0 1 0-1.371h3.25a.686.686 0 1 1 0 1.371ZM4.251 8.187c0-.378.307-.685.686-.685h.812a.686.686 0 1 1 0 1.371h-.812a.686.686 0 0 1-.686-.686Zm0 3.251c0-.379.307-.686.686-.686h2.438a.686.686 0 1 1 0 1.372H4.937a.686.686 0 0 1-.686-.686Z"
      clipRule="evenodd"
    />
  </svg>
)
export default AnexoIcon
